import * as React from 'react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { useTranslation } from 'react-i18next'
import {
  IVariantGeneIndexData,
  IVariantIndexData
} from '@/@core/services/app.service'
import Index from '.'
import { Chip, styled, Tooltip, TooltipProps } from '@mui/material'
import { formatDate } from '@/@core/utils/utils'

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  // [`& .${tooltipClasses.tooltip}`]: {
  //   backgroundColor: 'rgba(97, 97, 97)',
  //   color: 'rgb(255, 255, 255)',
  //   maxWidth: 220,
  //   fontSize: theme.typography.pxToRem(12),
  //   border: '1px solid #dadde9'
  // }
}))

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  )
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  }
}

export default function GeneIndexTabs(props: { value: IVariantGeneIndexData }) {
  const { t } = useTranslation()
  const [value, setValue] = React.useState(0)
  const columns = [
    {
      id: 'name',
      label: t('Sample name'),
      format: ((value: any) => {
        return <Typography fontSize={12}>{t(value)}</Typography>
      }) as any
    },
    {
      id: 'gender',
      label: t('Gender'),
      align: 'left',
      format: ((value: any) => {
        return <Typography fontSize={12}>{t(value)}</Typography>
      }) as any
    },
    {
      id: 'dateOfBirth',
      label: t('Birth Date'),
      align: 'left',
      format: ((value: any) => {
        return (
          <Typography fontSize={12}>
            {value ? formatDate(value, 'YYYY-MM-DD') : 'N/A'}
          </Typography>
        )
      }) as any
    },
    {
      id: 'phenotypes',
      label: t('phenotypes'),
      format: ((value: any) => {
        return (
          <Box>
            <HtmlTooltip
              title={value}
              placement="top"
              sx={{
                '& .MuiTooltip-tooltip': {
                  maxWidth: '400px !important',
                  fontSize: '0.85rem',
                  lineHeight: '1.5rem'
                }
              }}
            >
              <Typography
                maxWidth={320}
                sx={{
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}
                fontSize={12}
              >
                {value}
              </Typography>
            </HtmlTooltip>
          </Box>
        )
      }) as any
    },
    {
      id: 'terms',
      label: 'terms',
      format: ((value: any[]) => {
        const terms = value ?? []

        return (
          <Tooltip
            title={
              <Box>
                {terms.map((item: { title: string }, index) => {
                  return (
                    <Typography
                      key={`${item.title}_${index}`}
                      color="white"
                      fontSize={14}
                    >
                      {item.title}
                    </Typography>
                  )
                })}
              </Box>
            }
          >
            <Box
              sx={{
                maxWidth: 300
              }}
            >
              {terms.slice(0, 5).map((item: { title: string }, index) => {
                return (
                  <Chip
                    sx={{
                      m: 1,
                      fontSize: '0.75rem',
                      fontWeight: 400,
                      bgcolor: 'primary.main',
                      userSelect: 'text'
                    }}
                    label={item.title}
                    key={`${item.title}_${index}`}
                    color="info"
                    size="small"
                  />
                )
              })}
            </Box>
          </Tooltip>
        )
      }) as any
    }
  ]

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label={t('User')} {...a11yProps(0)} />

          <Tab label={t('Other')} {...a11yProps(1)} />
        </Tabs>
      </Box>

      <CustomTabPanel value={value} index={0}>
        <Box>
          <Index
            columns={columns as any}
            rows={props.value ? props.value.currentSamples : []}
          />
        </Box>
      </CustomTabPanel>

      <CustomTabPanel value={value} index={1}>
        <Index
          columns={columns as any}
          rows={props.value ? props.value.otherSamples : []}
        />

        {/* <Typography mt={4}>
          {`${t('Total')}: ${props.value.platformTotal} ${t('samples')}, ${t(
            'Samples with information'
          )}: ${
            props.value.platformTotal - props.value.notAvaiableSamplesTotal
          }`}
        </Typography> */}
      </CustomTabPanel>
    </Box>
  )
}
